// Fecha de corte de la cuenta de un administrador ("YYYY-MM-DD").
// El día de corte todavía se puede trabajar; al día siguiente la cuenta se bloquea.

const MS_POR_DIA = 24 * 60 * 60 * 1000;

// la fecha de corte es solo un día (sin hora): se toma al mediodía para que
// la zona horaria no la corra al día anterior
const aFecha = (fechaTexto) => new Date(`${fechaTexto}T12:00:00`);

export const formatearFechaCorte = (fechaTexto) =>
  fechaTexto ? aFecha(fechaTexto).toLocaleDateString("es-CO", { day: "numeric", month: "short", year: "numeric" }) : "Sin corte";

export const formatearFechaRegistro = (fechaIso) =>
  new Date(fechaIso).toLocaleDateString("es-CO", { day: "numeric", month: "short", year: "numeric" });

// días que le quedan a la cuenta (0 = hoy es el último día; negativo = vencida)
export const diasRestantes = (fechaTexto) => {
  const hoy = new Date();
  hoy.setHours(12, 0, 0, 0);
  return Math.round((aFecha(fechaTexto) - hoy) / MS_POR_DIA);
};

const DIAS_AVISO = 7;

// estado de la cuenta para mostrarlo como etiqueta: { texto, clase } (clases de badge de Bootstrap)
export const estadoFechaCorte = (fechaTexto, vencido) => {
  if (!fechaTexto) return { texto: "Sin corte", clase: "bg-secondary" };
  if (vencido) return { texto: "Vencida", clase: "bg-danger" };
  const dias = diasRestantes(fechaTexto);
  if (dias <= 0) return { texto: "Último día", clase: "bg-warning text-dark" };
  if (dias <= DIAS_AVISO) return { texto: `Vence en ${dias} ${dias === 1 ? "día" : "días"}`, clase: "bg-warning text-dark" };
  return { texto: "Vigente", clase: "bg-success" };
};
